import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import OrderReport from "./OrderReport";
import RentoutReport from "./RentoutReport";
import ReturnReport from "./ReturnReport";
import PaymentReport from "./PaymentReport";

export default function Report() {
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const type = query.get("type");

  const defaultReport = type === "scheduled" ? "rentout" : "orders";

  const [reportType, setReportType] = useState(defaultReport);

  return (
    <div className="card p-4">
      <h3>Reports</h3>

      <select
        className="form-control mb-4"
        value={reportType}
        onChange={(e) => setReportType(e.target.value)}
      >
        <option value="orders">Order Report</option>
        <option value="rentout">Rent Out Report</option>
        <option value="return">Return Report</option>
        <option value="payment">Payment Report</option>
      </select>

      {reportType === "orders" && <OrderReport />}
      {reportType === "rentout" && <RentoutReport />}
      {reportType === "return" && <ReturnReport />}
      {reportType === "payment" && <PaymentReport />}
    </div>
  );
}